import React from 'react';
import {View} from 'react-native';
import {observer} from 'mobx-react-lite';

import {MemberPriceCarousel} from '../../../../components/ProductCarousel';
import ExclusiveOffers from '../../../../components/rewards/ExclusiveOffers';
import ShopLoyaltyEnabled from '../../../../components/rewards/ShopLoyaltyEnabled';
import {useStores} from '../../../../stores/use-stores';
import {brandRewardsCopy} from '../../../../utils/rewards';
import CartItemsList from '../../components/CartItemsList';
import {EmptyCart} from '../../components/EmptyCart';
import type {StepContentProps} from '../types';

/**
 * Left side content for Cart step (Mode B)
 * Also used for Mode A (cart-fixed) for all steps
 *
 * Contains:
 * - Cart line items
 * - Member price carousel
 * - Exclusive offers
 */
const CartContent = observer((_props: StepContentProps) => {
  const {cartStore, rewardsStore} = useStores();
  const orderLines = cartStore.currentOrder?.order_lines;

  return (
    <View style={{gap: 16}}>
      <CartItemsList
        orderLines={orderLines}
        isLoading={cartStore.isLoadingOrder}
        emptyComponent={<EmptyCart isWebDesktopScreen />}
        testID="cart-content-items-list"
      />

      <ShopLoyaltyEnabled>
        <MemberPriceCarousel
          title={brandRewardsCopy.memberPublicPricingTitle.toUpperCase()}
          member_price="public"
          cartScreen
        />
        {rewardsStore.hasRewards ? <ExclusiveOffers variant="cart" /> : null}
      </ShopLoyaltyEnabled>
    </View>
  );
});

export default CartContent;
